// Module
var code = "<span class=\"structure-value-name label\" v-if=\"name\"> <span :class=\"{ hinted: !!description }\"> {{ name }} <span v-if=\"description\" class=\"hint right-hint\">{{ description }}</span> </span> </span> ";
// Exports
module.exports = code;